import Name from "@/components/Name"
import { useLocalStore } from "@/context/StateContext"
import { cn } from "@/utilities/cn"
import { A } from "@solidjs/router"
import { createEffect, createSignal, Index } from "solid-js"

export default function ItemsView() {
  const localStore = useLocalStore()
  const [items, setItems] = createSignal<any[] | null>(null)
  createEffect(async () => {
    if (!localStore.database) return
    const res = await localStore.database.find({
      selector: {

      }
    })
    // reduce to only qunique item.origin
    const origins = res.docs.reduce((acc, item) => {
      if (!acc.find((a) => a.origin === item.origin)) {
        acc.push(item)
      }
      return acc
    }, [])
    setItems(origins)
  })
  return (
    <div class="flex flex-col p-4 gap-4 overflow-y-auto">
      <h1>Items</h1>
      <Index each={items()} fallback={<p>No items found</p>}>
        {(item) => (
          <A class={"flex flex-row gap-2 p-4 border border-gray-200 rounded"} href={`/items/${item().origin}`}>
            <Name id={item().origin} />
          </A>
        )}
      </Index>
    </div>
  )
}
